import { render, staticRenderFns } from "./DeviceBloc.vue?vue&type=template&id=58192908&scoped=true"
import script from "./DeviceBloc.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceBloc.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeviceBloc.vue?vue&type=style&index=0&id=58192908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58192908",
  null
  
)

export default component.exports